module.exports = __webpack_public_path__ + "assets/img/hero.39d2947c.jpg";